// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130725/js/" + chunkId + "." + {"44":"4cc4fa2e","225":"2848d488","481":"e1473167","486":"e81c42bf","770":"781a12fe"}[chunkId] + ".0.7249035397876067.chunk.js";
};